import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getTaskTypes } from 'src/services/timeManagementService';
import React from 'react';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { TTaskType } from 'src/models/timesheet';

interface TaskTypeMultiSelectProps {
  value: number[] | [];
  onChange: (e: any) => void;
  projectId: string;
}

const TaskTypeMultiSelect = forwardRef(
  (props: TaskTypeMultiSelectProps, _ref) => {
    const dispatch = useDispatch();
    const [list, setList] = useState([]);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [searchText, setSearchText] = useState<string>('');

    const containsText = (text, searchText) =>
      text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

    const filteredLists = useMemo(
      () =>
        list.length > 0 &&
        list?.filter((option) => containsText(option?.typeName, searchText)),
      [list, searchText]
    );

    const getTaskApiHandler = () => {
      dispatch(AppActions.showLoader());
      getTaskTypes()
        .then((res) => {
          if (res.data.statusCode === 200) {
            const data: TTaskType[] = res.data?.data?.taskTypes || [];
            const modifyTypes: TTaskType[] = data.filter(
              (item: TTaskType) => item.typeName !== 'COMMON'
            );
            setList(modifyTypes);
          }
          dispatch(AppActions.hideLoader());
        })
        .catch((err) => {
          dispatch(AppActions.hideLoader());
        });
    };

    useEffect(() => {
      const selectedName = [];
      if (props?.value && props?.value.length > 0) {
        for (let i = 0; i < props?.value.length; i++) {
          const result = list.filter((e) => e.id === props?.value[i]);
          selectedName.push(result[0]?.typeName);
        }
      }
      setSelectedItems(selectedName);
    }, [list, props?.value]);

    React.useEffect(() => {
      getTaskApiHandler();
    }, []);

    return (
      <FormControl fullWidth>
        <InputLabel
          style={{
            fontSize: '12px'
          }}
        >
          Activity Type
        </InputLabel>
        <Select
          id="filter-resource"
          sx={{ mt: 1 }}
          style={{
            fontSize: '12px',
            height: '2rem'
          }}
          multiple
          size="small"
          value={props.value}
          renderValue={() => selectedItems.join(', ')}
          onChange={(e) => props?.onChange(e)}
          onClose={() => setSearchText('')}
        >
          <ListSubheader>
            <TextField
              id="search-task-id"
              size="small"
              autoFocus
              placeholder="Type to search..."
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                )
              }}
              onChange={(e) => setSearchText(e.target.value)}
              onClick={(e) => {
                e.stopPropagation();
              }}
              onKeyDown={(e) => {
                if (e.key !== 'Escape') {
                  e.stopPropagation();
                }
              }}
            ></TextField>
          </ListSubheader>
          {filteredLists?.length > 0 &&
            filteredLists.map((fl, i) => {
              return (
                <MenuItem key={fl?.id} value={fl?.id}>
                  <Checkbox
                    checked={props?.value.indexOf(fl?.id as never) > -1}
                  />
                  <ListItemText primary={fl?.typeName} />
                </MenuItem>
              );
            })}
        </Select>
      </FormControl>
    );
  }
);

export default TaskTypeMultiSelect;
